/**
 * Customer-specific dashboard styles based on new design mockup
 */

export const customerDashboardStyles = {
  layout: {
    bg: '#FFF',
    paddingTop: { base: '10px', md: '10px', xl: '10px' },
  },

  card: {
    bg: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0px 16px 40px rgba(15, 35, 52, 0.08)',
    padding: { base: '16px', md: '20px', lg: '24px' },
  },

  metricCard: {
    bg: '#F6F7FB',
    borderRadius: '16px',
    padding: { base: '16px', md: '20px', lg: '24px' },
  },

  headerAlert: {
    bg: '#FFECEC',
    borderRadius: '8px',
  },

  welcome: {
    bg: '#E7F5EC',
    borderRadius: '8px',
  },

  ctaBanner: {
    bg: 'linear-gradient(90deg, #4C6FFF 0%, #5BD3FF 100%)',
    borderRadius: '16px',
  },

  stats: {
    labelColor: '#6B7280',
    valueColor: '#111827',
  },

  table: {
    headerBg: '#FFF',
    borderRadius: '16px',
  },

  primaryButton: {
    bg: '#4C6FFF',
    color: '#FFFFFF',
    borderRadius: '999px',
  },
};

export default customerDashboardStyles;
